import { DefaultColumnRenderer } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { ColumnRendererProps } from '@dealstack/frontend/shared/components/Table/Table/types';
import classNames from 'classnames';

export const ColumnRenderer = (props: ColumnRendererProps): JSX.Element => {
	const isNumberColumn =
		props.column.id.endsWith('-cost') ||
		props.column.id.endsWith('-number') ||
		props.column.id.endsWith('-amount');

	return (
		<DefaultColumnRenderer
			{...props}
			style={isNumberColumn ? { width: `${props.column.width}px` } : {}}
			className={classNames('pl-4', {
				'text-left border-b border-solid border-gray-300 mr-4':
					props.column.id.startsWith('securities-values-') ||
					props.column.id.startsWith('loans-values-'),
				'pr-4 ml-0 flex justify-end': isNumberColumn,
			})}
		/>
	);
};
